// src/components/Footer.js
import React from 'react';
import { Box, Container, Typography, Link, Stack } from '@mui/material';
import { primaryColor } from '../theme';

const Footer = () => {
  return (
    <Box bgcolor={primaryColor} color="white" py={2} mt="auto">
      <Container maxWidth="lg">
        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems="center">
          <Typography variant="body2">
            © 2024 Content Portal. All rights reserved.
          </Typography>
          <Stack direction="row" spacing={2} justifyContent={{ xs: 'center', sm: 'flex-end' }}>
            <Link href="/privacy-policy" color="inherit" underline="none">
              Privacy Policy
            </Link>
            <Link href="/terms-of-service" color="inherit" underline="none">
              Terms of Service
            </Link>
            <Link href="/contact-us" color="inherit" underline="none">
              Contact Us
            </Link>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;